import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./Button.scss";

const buttonStyles = {
	blue: "primary_button",
	black: "black_button",
	white: "white_button",
	outlineWhite: "outline_white",
	outlineBlack: "outline_black",
};

const buttonSizes = {
	xsmall: "xsmall_button",
	small: "small_button",
	large: "large_button",
	fill: "fill_button",
};

const Button = ({
	link,
	styleName = "primary_button",
	size = "large",
	children,
}) => {
	const styleClass = buttonStyles[styleName] || buttonStyles.blue;
	const sizeClass = buttonSizes[size] || buttonSizes.large;

	return (
		<Link to={link} className={`button ${styleClass} ${sizeClass}`}>
			{children}
		</Link>
	);
};

Button.propTypes = {
	link: PropTypes.string.isRequired,
	styleName: PropTypes.oneOf([
		"blue",
		"black",
		"white",
		"outlineWhite",
		"outlineBlack",
	]),
	size: PropTypes.oneOf(["small", "large", "fill"]),
	children: PropTypes.node.isRequired,
};

export default Button;
